import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "../motion/Reveal";
import { useSite } from "../../lib/site";
import { scrollToId } from "../../lib/scroll";

export const Cta = () => {
  const { content } = useSite();
  const c = content.cta;
  return (
    <section className="bg-paper px-3 pb-3 sm:px-5 sm:pb-5" data-testid="cta-section">
      <div className="grain relative overflow-hidden rounded-[2.5rem] bg-ink text-white">
        <div className="grid lg:grid-cols-12">
          <div className="relative z-10 px-7 py-16 sm:px-14 sm:py-24 lg:col-span-7 lg:py-28">
            <Eyebrow>{c.eyebrow}</Eyebrow>
            <Reveal>
              <h2 className="mt-6 font-display text-4xl font-semibold leading-[0.98] tracking-[-0.04em] sm:text-6xl lg:text-[4.4rem]" data-testid="cta-title">{c.title}</h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl text-lg leading-relaxed text-[#C9D0E4]">{c.text}</p>
            </Reveal>
            <Reveal delay={0.2} className="mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <button onClick={() => scrollToId("registro")} className="btn-leaf group !py-5 sm:!px-9 sm:!text-base" data-testid="cta-primary">
                {c.primary} <ArrowUpRight className="btn-arrow h-5 w-5" />
              </button>
              <button onClick={() => scrollToId("como-funciona")} className="btn-ghost-dark group" data-testid="cta-secondary">
                {c.secondary} <ArrowDownRight className="h-5 w-5" />
              </button>
            </Reveal>
          </div>
          <div className="relative min-h-[320px] lg:col-span-5 lg:min-h-0">
            <div className="spotlight absolute inset-0 overflow-hidden lg:inset-y-6 lg:right-6 lg:rounded-[2rem]">
              <img src={content.media.cta_image} alt="Asesora comercial presentando una solución digital al dueño de una panadería" className="h-full w-full object-cover" />
            </div>
            <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-ink to-transparent lg:hidden" />
          </div>
        </div>
      </div>
    </section>
  );
};
